export function isEmpty(obj) {
    if (obj === void 0) { obj = {}; }
    // "new Date()" não tem keys, então também checa o construtor
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
